import { render, staticRenderFns } from "./EditAssignmentProduct.vue?vue&type=template&id=db17e9b0"
import script from "./EditAssignmentProduct.vue?vue&type=script&lang=js"
export * from "./EditAssignmentProduct.vue?vue&type=script&lang=js"
import style0 from "./EditAssignmentProduct.vue?vue&type=style&index=0&id=db17e9b0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports